import * as React from 'react';
import styled from 'styled-components';
import {
	AppBar,
	Tabs,
	Tab,
	VideocamOffIcon,
	VideocamIcon,
	LogoutIcon,
	CircularProgress,
	DropDownMenu,
} from '../material-ui';
import SwipeableViews from 'react-swipeable-views';
import cookies from 'js-cookie';

import CollectScreen from './Collect';
import RedeemScreen from './Redeem';
import LoginScreen from './Login';
import { client, setAuthFailCallback } from '../apollo-utils';
import { LogoutMutation, GetCinema } from '../queries';
import styleObject from '../style-object';
import { getAvailableCameras } from '../components/Scanner';

const screens = [CollectScreen, RedeemScreen];

const Wrapper = styled.div`
	flex: 1;
`;

const ScreenWrapper = styled.div`
	padding-top: 3rem;
	flex: 1;
`;

const appBarStyle = styleObject`
	flex-flow: row;
	padding: 0 1rem;
`;

const tabBarStyle = styleObject`
	flex: 1;
	margin: 0 1rem;
`;

const tabStyle = styleObject`
	max-width: 100%;
	margin-right: 1rem;
`;

const LoadingWrapper = styled.div`
	display: flex;
	flex: 1;
	min-height: 100vh;
	background: linear-gradient(0deg, #376df0, #19ddff);
	align-items: center;
	justify-content: center;
`;

const LoadingIndicator = styled(CircularProgress).attrs({
	color: 'secondary',
	size: 30,
})``;

class App extends React.Component {
	state = {
		tabIndex: 0,
		cinemaId: null,
		loggedIn: false,
		loading: true,
		cameraAvailable: false,
		cameraScannerEnabled: false,
	};

	componentDidMount = async () => {
		// check wether camera is available
		const cameras = await getAvailableCameras();
		let cameraScannerEnabled = window.localStorage.getItem('cameraScannerEnabled');
		if (typeof cameraScannerEnabled === 'string') {
			cameraScannerEnabled = cameraScannerEnabled === 'true';
		} else {
			cameraScannerEnabled =
				process.env.NODE_ENV === 'development' ||
				navigator.userAgent.toLowerCase().includes('android');
		}
		cameraScannerEnabled = cameraScannerEnabled && cameras.length > 0;
		this.setState({ cameraAvailable: cameras.length > 0, cameraScannerEnabled });
		// restore tab index from local storage
		const tabIndex = window.localStorage.getItem('tabIndex');
		if (tabIndex !== null) this.setState({ tabIndex: Number(tabIndex) });
		// try getting cinema id, if session is still active
		try {
			const { data } = await client.query({ query: GetCinema, errorPolicy: 'all' });
			if (data && data.posApp) {
				this.setState({ loggedIn: true, cinemaId: data.posApp.cinemaId, loading: false });
			} else {
				this.setState({ loading: false });
			}
		} catch (e) {
			if (e.networkError) this.setState({ loading: false });
			else throw e;
		}
		// set callback to set logedin status upon auth failure
		setAuthFailCallback(() =>
			this.setState({ loggedIn: false }, () =>
				// eslint-disable-next-line no-alert
				alert('Deine Sitzung ist abgelaufen, bitte logge dich erneut ein.')
			)
		);
	};

	handleChangeIndex = (e, tabIndex) => {
		// handle different api between tabs and swipeable-view
		if (typeof e === 'number') tabIndex = e;
		this.setState({ tabIndex }, () => {
			window.localStorage.setItem('tabIndex', tabIndex);
		});
	};

	handleLogout = async () => {
		localStorage.clear();
		await client.mutate({ mutation: LogoutMutation, errorPolicy: 'all' });
		client.resetStore();
		this.setState({ loggedIn: false }, () => cookies.remove('_csrf'));
	};

	handleLogin = ({ posApp: { cinemaId }, csrf }) => {
		cookies.set('_csrf', csrf, { expires: 365 * 2 });
		this.setState({ cinemaId, loggedIn: true });
	};

	handleToggleCameraScanner = () =>
		this.setState(
			(state) => ({ cameraScannerEnabled: !state.cameraScannerEnabled }),
			() => window.localStorage.setItem('cameraScannerEnabled', this.state.cameraScannerEnabled)
		);

	render = () =>
		this.state.loading ? (
			<LoadingWrapper>
				<LoadingIndicator />
			</LoadingWrapper>
		) : this.state.loggedIn ? (
			<Wrapper>
				<AppBar style={appBarStyle}>
					<Tabs
						style={tabBarStyle}
						value={this.state.tabIndex}
						onChange={this.handleChangeIndex}
						indicatorColor="secondary"
						fullWidth
						centered
					>
						{screens.map((Screen, i) => (
							<Tab style={tabStyle} key={i} label={Screen.label} />
						))}
					</Tabs>
					<DropDownMenu
						// eslint-disable-next-line react-perf/jsx-no-new-array-as-prop
						menuItems={[
							{
								key: 'logout',
								label: 'Ausloggen',
								Icon: <LogoutIcon />,
								onClick: this.handleLogout,
							},
							...(this.state.cameraAvailable
								? [
										{
											key: 'cam-allowed',
											label: `Camera Scanner ${
												this.state.cameraScannerEnabled ? 'deaktivieren' : 'aktivieren'
											}`,
											Icon: this.state.cameraScannerEnabled ? (
												<VideocamOffIcon />
											) : (
												<VideocamIcon />
											),
											onClick: this.handleToggleCameraScanner,
										},
								  ]
								: []),
						]}
					/>
				</AppBar>
				<SwipeableViews
					axis="x"
					index={this.state.tabIndex}
					onChangeIndex={this.handleChangeIndex}
					enableMouseEvents
				>
					{screens.map((Screen, i) => (
						<ScreenWrapper key={i}>
							<Screen {...this.state} active={i === this.state.tabIndex} />
						</ScreenWrapper>
					))}
				</SwipeableViews>
			</Wrapper>
		) : (
			<LoginScreen onLogin={this.handleLogin} />
		);
}

// export default App;
export default App;



// WEBPACK FOOTER //
// ./src/screens/index.js